import { createApp, h } from 'vue';

import GlobalPlugin from '@/vue-globals';
import App from '@/search-page/presentation/app.vue';
import { StudySearch } from '@/study-search';
import { SearchPage } from './search-page';
import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { SearchPageRouterReadyEvent } from '@studyportals/search-page-interface';
import { PortalType } from '@studyportals/domain-client';
import '@/study-search/models/prerender/Prerender';

declare global {
	interface Window {
		EventAggregationService: IEventAggregationService | undefined;
		PortalType: PortalType;
		PostHog: import('posthog-js').PostHog;
		CookieFirst: {
			acceptAllCategories: () => void;
			withdrawConsent: () => void;
		};
		prerenderReady: boolean;
	}
}

const app = createApp({
	render: () => {
		return h(App);
	},
});

void StudySearch.install(app);
void SearchPage.instance.install(app);

if (window.EventAggregationService) {
	window.EventAggregationService.publishTo(
		SearchPageRouterReadyEvent.EventType,
		new SearchPageRouterReadyEvent(SearchPage.instance.routing),
	);
}

app.use(GlobalPlugin);
app.mount('#SearchPagePlaceholder');
